// extracted by mini-css-extract-plugin
module.exports = {"blank-story-author":"jWSLq"};